module.exports = __webpack_public_path__ + "static/media/WfsSearchInput.be994a88.less";